var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"virtualmap"},[_c('div',{style:({ height: _vm.isRealTime ? '60vh' : '82vh' }),attrs:{"id":"virtual_map"}}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }